import { toast } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import logo from "../../assets/kangaroo/logoSmartKampus.png";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";
import LoginService from "../../services/LoginService";
import { KeyRound, ArrowLeft, ShieldCheck } from "lucide-react";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email")
      .required("Email is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const res = await LoginService.forgetpassword(values.email);
      toast.success(res.message || "Reset link sent to your email");
      // navigate("/reset-password");
      navigate("/reset-password", { state: { email: values.email } });
    } catch (error) {

      console.log("🚀 ~ handleSubmit ~ error:", error.response.data)
      toast.error(
        error.response?.data ||
        "Something went wrong. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container fluid className="vh-100 overflow-hidden p-0 bg-light">
      <Row className="g-0 h-100">

        {/* LEFT PANEL - Branded consistency */}
        <Col
          lg={7}
          className="d-none d-lg-flex flex-column justify-content-center align-items-center text-center text-white p-5"
          style={{
            background: "linear-gradient(135deg, #764ba2 0%, #c77dff 100%)",
          }}
        >
          <img
            src={logo}
            alt="Kangaroo Logo"
            className="img-fluid mb-4"
            style={{ maxHeight: "140px" }}
          />

          {/* <div>
            <h1
              className="m-0 p-0 font-level-4  text-uppercase"
              style={{ letterSpacing: "3px", lineHeight: "1" }}
            >
              Start Smart
            </h1>

            <h1
              className="font-level-4 fw-bold text-uppercase mt-0"
              style={{
                letterSpacing: "4px",
                color: "#7E1790",
                lineHeight: "1",
              }}
            >
              With Kangaroo
            </h1>
          </div> */}
          <hr
            className="w-25 my-1"
            style={{
              backgroundColor: "#F6921E",
              height: "3px",
              border: "none",
              opacity: 1
            }}
          />

          <Card className="bg-transparent border-0 w-75">
            <CardBody className="p-4">
              <h3 className="fw-bold mb-3 text-white">
                Where You Start Smart,Learn Continously, and Deliver with Confidence
              </h3>
              {/* <p className="fs-5 mb-0 text-white">
               Where Structured Information Empowers You To Start Smart and Deliver with Precision.
              </p> */}
            </CardBody>
          </Card>
        </Col>

        {/* RIGHT PANEL - Recovery Form */}
        <Col xs={12} lg={5} className="d-flex flex-column h-100 bg-white shadow-lg">

          <div className="flex-grow-1 d-flex align-items-center justify-content-center p-4 p-md-5">
            <Card className="border-0 w-100" style={{ maxWidth: "420px" }}>
              <CardBody className="p-0">

                {/* Header Icon */}
                <div className="text-center mb-5">
                  <div
                    className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "70px",
                      height: "70px",
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    }}
                  >
                    <KeyRound className="text-white" size={30} />
                  </div>
                  <h2 className="fw-bold text-dark mb-1">Forgot Password?</h2>
                  <p className="text-muted small">Please Enter your registered email below.</p>
                </div>

                <Formik
                  initialValues={{ email: "" }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                    <Form onSubmit={handleSubmit} noValidate>

                      <FormGroup className="form-floating mb-4">
                        <Input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="name@example.com"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          invalid={touched.email && !!errors.email}
                          className="rounded-3 border-2 shadow-sm"
                        />
                        <Label for="email">Email address</Label>
                        <FormFeedback>{errors.email}</FormFeedback>
                      </FormGroup>

                      <Button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-100 py-2 fw-bold shadow-sm mb-4"
                        style={{
                          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          border: "none",
                          height: "50px",
                          borderRadius: "10px"
                        }}
                      >
                        {isSubmitting ? (
                          <span className="spinner-border spinner-border-sm" />
                        ) : (
                          "Send Reset OTP"
                        )}
                      </Button>

                      <div className="text-center">
                        <Link
                          to="/login"
                          className="text-decoration-none d-inline-flex align-items-center gap-2 fw-semibold"
                          style={{ color: "#764ba2" }}
                        >
                          <ArrowLeft size={16} />
                          Back to Login
                        </Link>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </div>

          {/* Sticky Security Footer */}
          <div className="py-3 border-top bg-light text-center flex-shrink-0 w-100">
            <small className="text-muted d-flex align-items-center justify-content-center gap-2">
              <ShieldCheck size={14} className="text-success" />
              Your security is our priority
            </small>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;